export default "__VITE_ASSET__BsptIbLe__"